export default __webpack_public_path__ + "static/media/raki_detail5.7a394a3a.jpg";